// extracted by mini-css-extract-plugin
export default {"header":"invoices-page_header__cI2A0","newBtnText":"invoices-page_newBtnText__zC-ci","newBtnIcon":"invoices-page_newBtnIcon__SxalT"};